const getErrorCode = (error) => {
    return error.response?.status
}

export default getErrorCode
